<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.books')"
                :pgIcon="'bx bx-book'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=8

                :hasSearchFilter=true
                :hasCategoryFilter=true
                :hasDateFilter=true
                :hasStatusFilter=true
                :hasLecturerFilter=true

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=true
                :HasExport=true
                :hasShowEntries=true

                :lblSearch="$t('app.search')"

                :fields="{
                    'id': 'id',
                    'title': 'title',
                    'price': 'price',
                    'date': 'date',
                }"

                :hasImage=true
                :image="$t('view.book_image')"
                :image_style="'width: 50px;height: 50px'"

                :hasTitle=true
                :title="$t('view.book_title')"

                :hasCategory=true
                :category="$t('view.category_title')"

                :hasPrice=true
                :price="$t('view.book_price')"

                :hasPublishedDate=true
                :hasStatus=true
                :hasActions=true
                :hasDeleteButton=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'books',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            this.addNew = event;
        },
    },
}
</script>
